/**
 * Add Distributor Form Schema
 * 
 * Simple schema - user only enters the name.
 * distributorNumber is auto-generated by the backend.
 * 
 * Form metadata (name, title, description) is loaded from form.yml
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

// ============================================================================
// Export Form Metadata from YAML
// ============================================================================

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// ============================================================================
// Form Schema (What user fills in = what gets sent to API)
// ============================================================================

export const AddDistributorFormSchema = z.object({
  distributorNumber: z.number().optional(), // Business key for edit mode
  distributorName: z
    .string()
    .min(3, 'Name must be at least 3 characters')
    .max(60, 'Name cannot exceed 60 characters'),
})

export type AddDistributorFormData = z.infer<typeof AddDistributorFormSchema>

/**
 * Transform form data to API request format.
 * No transformation needed - API only requires the name.
 */
export function transformToApiRequest(formData: AddDistributorFormData) {
  return {
    distributorNumber: formData.distributorNumber, // Business key for upsert
    distributorName: formData.distributorName,
  }
}
